
import { computed, defineComponent, SetupContext, toRefs, watch, ref } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "CommonDesignDialog",
  props: {
    /**
     * ダイアログのアクティブ状態 (true: 活性、false: 非活性)
     */
    isShowDialog: {
      type: Boolean,
      default: false
    },
    /**
     * ダイアログのタイプ（「20221027パントリー_確定データ.xd」参照）
     */
    dialogType: {
      type: Number,
      required: true
    },
    /**
     * ダイアログに表示するタイトル 複数行表示する場合は、<br>で区切ること
     */
    title: {
      type: String,
      required: false
    },
    /**
     * ダイアログに表示するテキストメッセージ
     */
    message: {
      type: String,
      default: null
    },
    /**
     * ダイアログに表示するテキストメッセージ（HTML）
     */
    htmlMessage: {
      type: String,
      default: null
    },
    /**
     * メッセージの寄せ 0：左寄せ、1：中央よせ、2：右寄せ
     */
    messageAlign: {
      type: Number,
      default: 0
    },
    /**
     * メッセージ下の画像のリソース名（存在しなければデフォルト表示）
     */
    mainImage: {
      type: String,
      required: false
    },
    /**
     * ダイアログの黒ボタンに表示するテキスト（存在しなければ表示しない）
     */
    positiveLabel: {
      type: String,
      required: false
    },
    /**
     * ダイアログの白ボタンに表示するテキスト（存在しなければ表示しない）
     */
    negativeLabel: {
      type: String,
      required: false
    },
    /**
     * ダイアログ最下部のテキスト・ボタン名称
     */
    textButtonTitle: {
      type: String,
      default: "閉じる"
    }
  },
  setup(props, context: SetupContext) {

    // メッセージ変化の監視
    // const { watchMessage } = toRefs(props);
    // watch(watchMessage, () => {
    //   NativeClient.sendDebugLog("CommonOKDialog watch");
    //   if (watchMessage.value != "") {
    //     NativeClient.sendDebugLog("CommonOKDialog watch log enable");
    //     const logInfo = new BeaconLogInfo(PAGE_ID.DIALOG, null, [watchMessage.value]);
    //     //NativeClient.sendViewedLog(logInfo);
    //   }
    // });

    //
    // ダイアログのタイプで決定するもの
    //

    // ダイアログの高さ
    const styleDialogHeight = computed(() => {
      let retValue = { };
      switch(props.dialogType) {
        case 16:
        case 17:
        case 20:
          retValue = { height: '90%'};
          break;
        default:
          retValue = { height: 'fit-content'};
          break;
      }
      return retValue;
    });

    // コンテンツの高さ
    const styleContentsHeight = computed(() => {
      let retValue = { };
      switch(props.dialogType) {
        case 16:
        case 17:
          retValue = { 'height': 'calc(100% - 11.2rem)' };
          break;
        case 20:
          retValue = { 'height': 'calc(100% - 18.4rem)' };
          break;
        default:
          retValue = { 'height': 'fit-content' };
          break;
      }
      return retValue;
    });

    // 画像＋メッセージの高さ
    const styleImageMessageHeight = computed(() => {
      let retValue = { };
      switch(props.dialogType) {
        case 16:
        case 17:
        case 20:
          retValue = { 'height': 'calc(100% - 2.7rem)' };
          break;
        default:
          retValue = { 'max-Height': '32rem'};
          break;
      }
      return retValue;
    });

    // トップのマージン
    const isTopDisplay = computed(() => {
      let retValue = true;
      switch(props.dialogType) {
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
          retValue = false;
          break;
        default:
          retValue = true;
          break;
      }
      return retValue;
    });

    // 「X」ボタン表示
    const isTopCloseButton = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 4:
        case 5:
        case 6:
        case 7:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // メッセージのみ
    const isMessageOnly = computed(() => {
      // メッセージのみでボタン等が存在しない場合、ここでtrueを返す
      return false;
    });

    // タイトルとメッセージが存在場合
    const isTitleAndMessage = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 3:
        case 6:
        case 9:
        case 10:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
        case 20:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // 注意喚起の画像の表示／非表示
    const isTypeImageDisplay = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // ダイアログのタイトル
    const isDialogTitle = computed(() => {
      let retValue = true;
      switch(props.dialogType) {
        case 1:
        case 2:
        case 18:
          retValue = false;
          break;
        default:
          retValue = true;
          break;
      }
      return retValue;
    });

    const isImageAndMessage = computed(() => {
      let retValue = true;
      switch(props.dialogType) {
        case 16:
        case 17:
        case 20:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // メッセージ
    const isNormalMessage = computed(() => {
      if (props.message == null) {
        return false;
      }
      let retValue = false;
      switch(props.dialogType) {
        case 2:
        case 3:
        case 6:
        case 9:
        case 10:
        case 13:
        case 14:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // HTMLメッセージ
    const isHTMLMessage = computed(() => {
      if (props.message != null || props.htmlMessage == null) {
        return false;
      }
      let retValue = false;
      switch(props.dialogType) {
        case 2:
        case 3:
        case 6:
        case 9:
        case 10:
        case 13:
        case 14:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // タイトル下のマージン
    const isNeedTitleBottomMargin = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 11:
        case 15:
          retValue = true;
          break;
        default:
          break;
      }
      return retValue;
    });

    // 注意等のアイコン
    const typeImage = () => {
      switch(props.dialogType) {
        case 8:
        case 9:
        case 10:
        case 11:
          return require("@/assets/images/icon_caution_fill.png");
        case 12:
        case 13:
        case 14:
        case 15:
          return require("@/assets/images/icon_done_fill.png");
        default:
          return require("@/assets/images/noimage.png");;
      }
    };

    // メインの画像
    const isDialogMainImageDisplay = computed(() => {
      NativeClient.sendDebugLog("CommonDesignDialog dialogType = " + props.dialogType);
      switch(props.dialogType) {
        case 7:
        case 16:
        case 17:
        case 20:
        case 21:
          return true;
        default:
          return false;
      }
    });
    const dialogMainImage = () => {
      switch(props.dialogType) {
        case 7:
        case 16:
        case 17:
        case 20:
        case 21:
          if (props.mainImage != null) {
            NativeClient.sendDebugLog("CommonDesignDialog displayImage = " + props.mainImage);
            return props.mainImage;
          } else {
            NativeClient.sendDebugLog("CommonDesignDialog displayImage = default_dialog_main_image.png");
            return require("@/assets/images/default_dialog_main_image.png");
          }
        default:
          return require("@/assets/images/noimage.png")
      }
    };

    const isExistMessageImage = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 2:
        case 3:
        case 6:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
          retValue = true;
          break;
        default:
          break;
      }
      return retValue;
    });

    // ダイアログ最下部のボタンの表示／非表示
    const isBottomDisplay = computed(() => {
      // 最下部のボタンを表示しない場合は、ここでfalseを返す
      return true;
    });
    const isDisplayBottomSelection = computed(() => {
      let retValue = true;
      switch (props.dialogType) {
        case 2:
        case 3:
        case 6:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
          retValue = true;
          break;
        default:
          retValue = false;
      }
      return retValue
    });

    // ダイアログ最下部「閉じる」ボタンの表示／非表示
    const isDisplayBottomTextButton = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 20:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // ダイアログ最下部のボタンの並び
    const isBottomButtonRowDirection = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 6:
        case 10:
        case 11:
        case 14:
        case 15:
        case 17:
        case 18:
        case 19:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // 通常のボタンとテキストボタンのマージン
    const isExistNormalButtonAndTextButton = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 20:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });

    // 黒色ボタンの表示／非表示
    const isNegativeButtonDisplay = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 2:
        case 3:
        case 6:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 21:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });
    const styleRowNegativeButton = computed(() => {
      switch (props.dialogType) {
        case 6:
        case 10:
        case 11:
        case 14:
        case 15:
        case 17:
        case 18:
        case 19:
          return { width: 'calc(50% - 0.8rem)'};
        default:
          break
      }
      return { width: '100%' };
    });

    // 白色ボタンの表示／非表示
    const isPositiveButtonDisplay = computed(() => {
      let retValue = false;
      switch(props.dialogType) {
        case 6:
        case 10:
        case 11:
        case 14:
        case 15:
        case 17:
        case 18:
        case 19:
        case 20:
          retValue = true;
          break;
        default:
          retValue = false;
          break;
      }
      return retValue;
    });
    const styleRowPositiveButton = computed(() => {
      switch (props.dialogType) {
        case 6:
        case 10:
        case 11:
        case 14:
        case 15:
        case 17:
        case 18:
        case 19:
          return { width: 'calc(50% - 0.8rem)'};
        default:
          break
      }
      return { width: '100%' };
    });

    // メッセージの寄せ
    const styleMessageAlignment = computed(() => {
      let retStyle = { textAlign: 'left' };
      switch (props.messageAlign) {
      case 1:
        retStyle = { textAlign: 'center' };
        break;
      case 2:
        retStyle = { textAlign: 'right'};
        break;
      default:
        break;
      }
      return retStyle;
    });
        
    // スクロール・トップに戻す（閉じる際に呼び出すこと）
    // ユーザーがスクロール操作した場合、Vueはそのスクロール位置を記憶してしまい、次の表示で記憶したスクロール位置で表示してしまうことを回避する
    // 閉じる際でないと、スクロール位置等が決定していないため、スクロール位置が初期の位置に戻らない
    const scrollMessageImageTop = () => {
      const elementList = document.getElementsByClassName("dialog-box-contents-messageimage");
      if (elementList == null || elementList.length ==0) {
        return;
      }
      elementList[0].scrollTop = 0;
    };

    // 白色ボタンが押されたことを通知する
    const negativeClicked = () => {
      NativeClient.sendDebugLog("CommonDesignDialog negativeClicked");
      context.emit("negative-click");
      scrollMessageImageTop();
    }

    // 黒色ボタンが押されたことを通知する
    const positiveClicked = () => {
      NativeClient.sendDebugLog("CommonDesignDialog positiveClicked");
      context.emit("positive-click");
      scrollMessageImageTop();
    };

    // 「閉じる」ボタンが押されたことを通知する
    const closeClicked = () => {
      NativeClient.sendDebugLog("CommonDesignDialog closeClicked");
      context.emit("close-click");
      scrollMessageImageTop();
    };

    // 最下部のテキスト・ボタンが押されたことを通知する
    const bottomTextClicked = () => {
      NativeClient.sendDebugLog("CommonDesignDialog bottomTextClicked");
      context.emit("textbutton-click");
      scrollMessageImageTop();
    };

    return {
      isTopDisplay,
      isTopCloseButton,
      isTitleAndMessage,
      isMessageOnly,
      isTypeImageDisplay,
      typeImage,
      isDialogTitle,
      isImageAndMessage,
      isNormalMessage,
      isHTMLMessage,
      styleDialogHeight,
      styleContentsHeight,
      styleMessageAlignment,
      styleImageMessageHeight,
      isNeedTitleBottomMargin,
      isDialogMainImageDisplay,
      dialogMainImage,
      isExistMessageImage,
      isBottomDisplay,
      isDisplayBottomSelection,
      isDisplayBottomTextButton,
      isBottomButtonRowDirection,
      isNegativeButtonDisplay,
      styleRowNegativeButton,
      isPositiveButtonDisplay,
      styleRowPositiveButton,
      isExistNormalButtonAndTextButton,
      negativeClicked,
      positiveClicked,
      closeClicked,
      bottomTextClicked
    };
  }
});
